import * as React from 'react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined';
import DragHandleOutlinedIcon from '@mui/icons-material/DragHandleOutlined';
import { Download } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { officerVehicles } from '../../constants/officerVehicles';
import CircularProgress from '@mui/material/CircularProgress';
import PieChart from '../../components/PieChart';
import TitleGrid from '../../components/TitleGrid';
import VehicleChartTable from '../../components/VehicleChartTable';
import WeeklySeatScore from '../../components/WeeklySeatScore';
import WeeklySeatScoreWrap from '../../components/WeeklySeatScoreWrap';
import '../../components/styles/custom.css';
import service from '../service';
import { beforePrinting, afterPrinting } from '../../utils';
import moment from 'moment';
import { reportTypes } from '../../constants/reportTypes';


//28.09.2024 - 29.09.2024
const isWeekend = (beginDate, endDate) => {
  const begin = moment(beginDate).day();
  const end = moment(endDate).day();

  return (begin === 6 || begin === 0) && (end === 6 || end === 0);
};

const HandleNoData = ({ text, beginDate, endDate, rawData }) => {
  return (
    <div className="w-full flex justify-center items-center bg-blue-100 p-5 my-4">
      {isWeekend(beginDate, endDate) &&
        officerVehicles.includes(
          rawData.request.parameterJson.vehicleId,
        ) ? (
        <Typography variant="h5" color="initial">
          Bu Araç Hafta Sonu Görev Yapmamaktadır.
        </Typography>
      ) : (
        <Typography variant="h5" color="initial">
          {text}
        </Typography>
      )}
    </div>
  );
};

const WeeklyReport = (props) => {
  const changeHeader = () => {
    document.title = `${rawData?.request.schema.id === reportTypes.KV_Vehicle_Report
      ? rawData.request.parameterJson.vehicleId + ' '
      : ''
      }Yerlem Kavi ${reportType.tr} Raporu ${vehicleSafetyReport?.dateTitle}`;
  };
  const handleDownload1 = () => {
    document.title = `${rawData?.request.schema.id === reportTypes.KV_Vehicle_Report
      ? rawData.request.parameterJson.vehicleId + ' '
      : ''
      }Yerlem Kavi ${reportType.tr} Raporu ${vehicleSafetyReport?.dateTitle}`;
    window.print();
  };


  const params = useParams();

  const [vehicleSafetyReport, setVehicleSafetyReport] = useState(null);
  const [rawData, setRawData] = useState(null);
  const [carData, setCarData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [beginDate, setBeginDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const getVehicleReportByRequestId = async () => {
    setIsLoading(true);
    const res = await service.getToken().then((res) => res);
    let token = res.data.data.token;

    const result = await service.getReportingResponseByRequestId(
      { requestId: params.id },
      token,
    );
    const rawData = result?.data?.data[0];
    const resultJson = rawData?.resultJson;
    const parameterJson = rawData?.request?.parameterJson;
    const sortedData = resultJson?.data?.sort((a, b) => b.score - a.score);
    setRawData(rawData);
    setVehicleSafetyReport(resultJson);
    setBeginDate(parameterJson.beginDate);
    setEndDate(parameterJson.endDate);
    setCarData(sortedData);
    setIsLoading(false);
  };

  useEffect(() => {
    window.addEventListener('beforeprint', beforePrinting);
    window.addEventListener('afterprint', afterPrinting);
    return () => {
      window.removeEventListener('beforeinput', beforePrinting);
      window.removeEventListener('afterprint', afterPrinting);
    };
  }, []);

  useEffect(() => {
    getVehicleReportByRequestId();
  }, []);

  useEffect(() => {
    changeHeader();
  }, [vehicleSafetyReport]);

  useEffect(() => {
    const pageBreakElements = document.querySelectorAll('.page-content');

    // Get the page height
    const pageHeight = 2100;

    let cumulativeHeight = 0;

    // console.log(pageBreakElements, 'pageBreakElements')
    pageBreakElements.forEach((element, index) => {
      const currentElementHeight = element.scrollHeight;

      cumulativeHeight += currentElementHeight;

      if (index === 0) {
        // First element
        element.classList.add('page-break');
      } else if (cumulativeHeight > pageHeight) {
        element.classList.add('page-break');
        cumulativeHeight = currentElementHeight;
      } else {
        element.classList.remove('page-break');
      }
      // console.log(index, 'index')
      // console.log(pageHeight, 'pageHeight')
      // console.log(element, 'element');
      // console.log(currentElementHeight, 'currentElementHeight')
      // console.log(cumulativeHeight, 'cumulativeHeight')
    });
  }, [carData, vehicleSafetyReport, isLoading]);
  const reportType =
    rawData?.request.schema.id === reportTypes.KV_Fleet_Report
      ? { tr: 'Filo', en: 'Fleet' }
      : { tr: 'Araç', en: 'Vehicle' };

  return (
    <>
      {isLoading ? (
        <div className="w-screen h-screen flex justify-center items-center m-5">
          <CircularProgress />
        </div>
      ) : (
        <div
          id="weeklyReport"
          className="w-full flex flex-col justify-center items-center"
        >
          <div className="hiddenForPrint flex justify-between items-center  w-[1560px]">
            <Button onClick={handleDownload1}>Pdf Olarak Kaydet</Button>
            <Typography variant="p" color="initial">
              Rapor Oluşturulma Süresi: {rawData.elapsed}
            </Typography>
          </div>
          <div id="reportPage" className="text-center w-[1560px]">
            {reportType.tr === 'Filo' ? null : (
              <TitleGrid
                title={rawData.request.parameterJson.vehicleId}
                padding={1}
                titleFontSize="h5"
                widthRate={12}
              />
            )}
            <TitleGrid
              title={
                moment(beginDate).format('DD.MM.YYYY') +
                ' - ' +
                moment(endDate).format('DD.MM.YYYY')
              }
              padding={1}
              titleFontSize="h5"
              widthRate={12}
            />
            <TitleGrid
              title={`KONYA HPC Haftalık Yerlem Kavi ${reportType.tr} Raporu`}
              titleFontSize="h5"
              padding={1}
              widthRate={12}
            />
            <Grid container item xs={12}>
              <Grid item xs={4}>
                <TitleGrid
                  title={`Son 12 Ay ${reportType.tr} Güvenlik Ortalaması`}
                  // title2={`${reportType.en} Safety Average for the Last 12 Months`}
                  widthRate={12}
                  marginTop={2}
                  padding={2}
                  marginRight="10px"
                  titleFontSize="h6"
                />
                {vehicleSafetyReport?.last12MonthlyScore >= 0 &&
                  vehicleSafetyReport?.data?.length > 0 &&
                  vehicleSafetyReport.past12MonthlyScore >= 0 ? (
                  <>
                    <PieChart
                      safe={vehicleSafetyReport?.last12MonthlyScore}
                      haveLegend={true}
                      widthRate={12}
                    />
                    <GetDifference
                      difference={
                        vehicleSafetyReport?.last12MonthlyScore -
                        vehicleSafetyReport?.past12MonthlyScore
                      }
                    />
                  </>
                ) : (
                  <HandleNoData
                    text="Son 12 Aylık Veri Bulunamadı."
                    beginDate={beginDate}
                    endDate={endDate}
                    rawData={rawData}
                  />
                )}
              </Grid>

              <Grid item xs={4}>
                <TitleGrid
                  title={`Aylık ${reportType.tr} Güvenlik Ortalaması`}
                  // title2={`Monthly ${reportType.en} Safety Average`}
                  padding={2}
                  widthRate={12}
                  marginTop={2}
                  titleFontSize="h6"
                />

                {vehicleSafetyReport?.monthlyScore >= 0 &&
                  vehicleSafetyReport?.data?.length > 0 &&
                  vehicleSafetyReport.pastMonthlyScore >= 0 ? (
                  <>
                    <PieChart
                      safe={vehicleSafetyReport?.monthlyScore}
                      haveLegend={true}
                      widthRate={12}
                    />
                    <GetDifference
                      difference={
                        vehicleSafetyReport?.monthlyScore -
                        vehicleSafetyReport?.pastMonthlyScore
                      }
                    />
                  </>
                ) : (
                  <HandleNoData
                    text="Aylık Araç Verisi Bulunamadı."
                    beginDate={beginDate}
                    endDate={endDate}
                    rawData={rawData}
                  />
                )}
              </Grid>

              <Grid item xs={4}>
                <TitleGrid
                  title={`Haftalık ${reportType.tr} Güvenlik Ortalaması`}
                  // title2={`Weekly ${reportType.en} Safety Average`}
                  widthRate={12}
                  marginTop={2}
                  padding={2}
                  marginLeft="10px"
                  titleFontSize="h6"
                />
                {vehicleSafetyReport?.weeklyScore >= 0 &&
                  vehicleSafetyReport?.data?.length > 0 &&
                  vehicleSafetyReport.pastWeeklyScore >= 0 ? (
                  <>
                    <PieChart
                      safe={vehicleSafetyReport?.weeklyScore}
                      haveLegend={true}
                      widthRate={12}
                    />
                    <GetDifference
                      difference={
                        vehicleSafetyReport?.weeklyScore -
                        vehicleSafetyReport?.pastWeeklyScore
                      }
                    />
                  </>
                ) : (
                  <HandleNoData
                    text="Haftalık Araç Verisi Bulunamadı."
                    beginDate={beginDate}
                    endDate={endDate}
                    rawData={rawData}
                  />
                )}
              </Grid>

              {vehicleSafetyReport?.last6MonthlyScore?.length > 0 ? (
                <VehicleChartTable
                  title={`Son 6 Hafta ${reportType.tr} Güvenlik Ortalaması`}
                  // title2={`${reportType.en} Safety Average for the Last 6 Weeks`}
                  needJsonPoint={false}
                  json={vehicleSafetyReport?.last6MonthlyScore}
                />
              ) : (
                <div className="w-full flex justify-center items-center bg-blue-100 p-5 my-4">
                  <Typography variant="h5" color="initial">
                    Son 6 Haftalık Veri Bulunamadı.
                  </Typography>
                </div>
              )}

              {vehicleSafetyReport?.data?.length > 0 ? (
                <VehicleChartTable
                  title={`Haftalık ${reportType.tr} Güvenlik Ortalaması`}
                  // title2={`Weekly ${reportType.en} Safety Average`}
                  json={vehicleSafetyReport}
                  rawData={rawData}
                  carData={carData}
                />
              ) : (
                <HandleNoData
                  text="Araç Verisi Bulunamadı."
                  beginDate={beginDate}
                  endDate={endDate}
                  rawData={rawData}
                />
              )}
            </Grid>
            {carData?.map((item, index) => {
              if (officerVehicles?.includes(item?.plate)) {
                return (
                  <GetCarReportWrap
                    vehicleSafetyReport={vehicleSafetyReport}
                    key={index}
                    carJson={item}
                  />
                );
              } else {
                return (
                  <GetCarReport
                    vehicleSafetyReport={vehicleSafetyReport}
                    key={index}
                    carJson={item}
                  />
                );
              }
            })}
          </div>
        </div>
      )}
    </>
  );
};

const GetCarReport = ({ carJson, vehicleSafetyReport }) => {
  //console.log(carJson)

  const carScore =
    typeof carJson.score !== 'undefined' ? ' (% ' + carJson.score + ')' : '';

  return (
    <Grid
      style={{
        marginBottom: '10px',
      }}
    >
      <WeeklySeatScore
        newData={carJson}
        vehicleSafetyReport={vehicleSafetyReport}
        plate={carJson.plate + carScore}
      />
    </Grid>
  );
};
const GetCarReportWrap = ({ carJson, vehicleSafetyReport }) => {
  //console.log(carJson)

  const carScore =
    typeof carJson.score !== 'undefined' ? ' (% ' + carJson.score + ')' : '';

  return (
    <Grid
      style={{
        marginBottom: '10px',
      }}
    >
      <WeeklySeatScoreWrap
        newData={carJson}
        vehicleSafetyReport={vehicleSafetyReport}
        plate={carJson.plate + carScore}
      />
    </Grid>
  );
};

function GetDifference({ difference }) {
  if (difference < 0) {
    return (
      <Grid style={{ color: 'red' }}>
        <ArrowCircleDownOutlinedIcon fontSize="large" sx={{ color: 'red' }} />%{' '}
        {difference.toFixed(2) * -1}
      </Grid>
    );
  } else if (difference == 0) {
    return (
      <Grid style={{ color: 'grey' }}>
        <DragHandleOutlinedIcon fontSize="large" sx={{ color: 'grey' }}>
          % 0
        </DragHandleOutlinedIcon>
      </Grid>
    );
  } else {
    return (
      <Grid style={{ color: 'green' }}>
        <ArrowCircleUpOutlinedIcon fontSize="large" sx={{ color: 'green' }} />%{' '}
        {difference.toFixed(2)}
      </Grid>
    );
  }
}

export default WeeklyReport;
